// @flow

const createLogicalCompositorWith = (method: string) => (
  ...predicates: any
) => (...args: []) => predicates[method](predicate => predicate(...args));

export default createLogicalCompositorWith;
